// ─────────────────────────────────────────────
//  ResultStrip.jsx — Comparación PPU + ganador
// ─────────────────────────────────────────────

import React from 'react';
import styles from './ResultStrip.module.css';
import { PRODUCT_COLORS } from './PriceComparator';

// Semántica UX: verde = ganador
const WINNER_GREEN = '#30D158';

function formatPPU(value) {
	if (!value || value === 0) return '—';
	if (value < 0.001) return `$${value.toFixed(5)}`;
	if (value < 0.01)  return `$${value.toFixed(4)}`;
	if (value < 1)     return `$${value.toFixed(3)}`;
	return `$${value.toFixed(2)}`;
}

function PPUItem({ id, ppu, unit, winner, hasData }) {
	const isWinner     = hasData && winner === id;
	const productColor = PRODUCT_COLORS[id]?.dot ?? '#fff';
	const showVal      = hasData || ppu > 0;

	return (
		<div className={`${styles.item} ${isWinner ? styles.itemWinner : ''}`}>
			{isWinner && (
				<span className={styles.winnerBadge}>
					✓ Mejor precio
				</span>
			)}
			<span
				className={styles.ppuProductLabel}
				style={{ color: productColor }}
			>
				{id}
			</span>
			<span
				className={`${styles.ppuValue} ${isWinner ? styles.winnerValue : ''}`}
				style={{ color: isWinner ? WINNER_GREEN : 'rgba(255,255,255,0.6)' }}
			>
				{showVal ? formatPPU(ppu) : '—'}
			</span>
			<span
				className={styles.ppuUnit}
				style={{ color: isWinner ? WINNER_GREEN : 'rgba(255,255,255,0.25)' }}
			>
				/{unit}
			</span>
		</div>
	);
}

export default function ResultStrip({
	ppuA, ppuB, ppuC,
	unit,
	winner,
	barFillPct,
	savingsText,
	hasData,
	showC,
	hasC,
}) {
	return (
		<div className={styles.card}>

			<p className={styles.label}>
				{hasData ? `Precio por ${unit}` : 'Precio por unidad'}
			</p>

			<div className={`${styles.compareRow} ${showC ? styles.threeCol : ''}`}>
				<PPUItem id="A" ppu={ppuA} unit={unit} winner={winner} hasData={hasData} />

				{!showC && <div className={styles.vsPill}>VS</div>}

				<PPUItem id="B" ppu={ppuB} unit={unit} winner={winner} hasData={hasData} />

				{showC && (
					<PPUItem
						id="C"
						ppu={hasC ? ppuC : 0}
						unit={unit}
						winner={winner}
						hasData={hasData && hasC}
					/>
				)}
			</div>

			{hasData && (
				<div className={styles.savingsWrap}>
					<div className={styles.barBg}>
						<div
							className={styles.barFill}
							style={{ width: `${barFillPct}%` }}
						/>
					</div>
					<p className={styles.savingsText} aria-live="polite">
						{savingsText}
					</p>
				</div>
			)}

		</div>
	);
}
